/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Updateyourlistinginformation3Inputs */

const en_updateyourlistinginformation3 = /** @type {(inputs: Updateyourlistinginformation3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update your listing information`)
};

const de_updateyourlistinginformation3 = /** @type {(inputs: Updateyourlistinginformation3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ändere die Infos zu deinem Ort`)
};

/**
* | output |
* | --- |
* | "Update your listing information" |
*
* @param {Updateyourlistinginformation3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const updateyourlistinginformation3 = /** @type {((inputs?: Updateyourlistinginformation3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Updateyourlistinginformation3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_updateyourlistinginformation3(inputs)
	return de_updateyourlistinginformation3(inputs)
});
export { updateyourlistinginformation3 as "updateYourListingInformation" }